import React, { useEffect, useMemo, useState } from 'react';
import '../UI/TestEntrymodal.css';
import { GetDataBySearch, Get_AgeGroup, Get_Categorry, Get_SubCategory } from '../Services/TestServices';
import SpinnerModal from '../Spinner/SpinnerModal';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Divider, Button, Chip } from '@mui/material';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import { toast } from 'react-toastify';
import CancelIcon from '@mui/icons-material/Cancel';
import '../UI/LabOrder.css';

const ABBREVIATION_MAP = {
  cbc: "complete blood count",
  hb: "hemoglobin",
  tc: "total count",
  dc: "differential count",
  esr: "erythrocyte sedimentation rate",
  crp: "c-reactive protein",
  rbs: "random blood sugar",
  fbs: "fasting blood sugar",
  ppbs: "postprandial blood sugar",
  hba1c: "glycated hemoglobin",
  lft: "liver function test",
  rft: "renal function test",
  kft: "kidney function test",
  "s. urea": "serum urea",
  "s.urea": "serum urea",
  urea: "serum urea",
  "s. creatinine": "serum creatinine",
  "s.creatinine": "serum creatinine",
  creatinine: "serum creatinine",
  pt: "prothrombin time",
  inr: "international normalized ratio",
  aptt: "activated partial thromboplastin time",
  abg: "arterial blood gas",
  "na+": "sodium",
  na: "sodium",
  "k+": "potassium",
  k: "potassium",
  tft: "thyroid function test",
  upt: "urine pregnancy test"
};

const LabOrder = React.memo(({ onSubmit, patientName }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [AgegroupData, SetAgegroupData] = useState([]);

  const [searchData, setSearchData] = useState([]);
  const [selectedTests, setSelectedTests] = useState([]);
  const [totalprice, setTotalPrice] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [DiscountAmmount, setDiscountAmmount] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [ReceivedAmount, SetReceivedAmount] = useState(0);
  const [DueAmount, SetDueAmount] = useState(0);

  const [isReset, setIsReset] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false); // Modal control state
  const [discountType, setDiscountType] = useState("percentage"); // percentage | amount
  const [Params, setParams] = useState({
    SearchParam: '',
    GenderCategory: '',
    AGE_CODE: '',
    LabID: sessionStorage.getItem('LabID'),
  });

  const onChange = (e) => {
    const { name, value } = e.target;
    setParams({
      ...Params,
      [name]: value,
    });
  };

  // Reset State after submitting form Successfully
  useEffect(() => {
    if (isReset) {
      setParams({
        SearchParams: '',
        GenderCategory: '',
        AGE_CODE: '',
        LabID: sessionStorage.getItem('LabID'),
      });
      setSearchTerm("");
      setActiveCategory(null);
      setActiveSubCategory(null);
      setSelectedTests([]);
      setTotalPrice(0);
      setDiscount(0);
      setGrandTotal(0);
      SetReceivedAmount(0);
      SetDueAmount(0);
      setIsReset(false);
    }
  }, [isReset]);

  // Search test
  const getTestsList = async (e) => {
    setIsLoading(true);
    try {
      const response = await GetDataBySearch(Params);
      setSearchData(response);
    } catch (error) {
      console.log('Error while searching test', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTestsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Select and Add test
  const addToSelectedTests = (testItem) => {
    const isTestSelected = selectedTests.some((selectedTest) => selectedTest.testID === testItem.testID);
    if (isTestSelected) {
      toast.warning('Test Already selected');
    } else {
      setSelectedTests([...selectedTests, { ...testItem, quantity: 1 }]);
    }
  };

  // Add every test in a favorited group (Category / Sub Category) directly, same
  // one-click behaviour as clicking an individual favorite test chip.
  const addAllMatchingTests = (items) => {
    if (!items || items.length === 0) return;
    const existingIds = new Set(selectedTests.map((t) => t.testID));
    const newItems = items.filter((t) => !existingIds.has(t.testID)).map((t) => ({ ...t, quantity: 1 }));
    if (newItems.length === 0) {
      toast.info('These tests are already selected');
      return;
    }
    setSelectedTests([...selectedTests, ...newItems]);
    toast.success(`${newItems.length} test(s) added to the selected list`);
  };

  // Remove test from selected test
  const removeTest = (id) => {
    const updatedList = selectedTests.filter((x) => x.testID !== id);
    setSelectedTests(updatedList);
  };

  // Reset the search box text only
  const ResetSearchList = () => {
    setSearchTerm("");
  };

  // Price Calculation
  useEffect(() => {
    calculateTotalPrice();
  }, [selectedTests, discount, discountType, ReceivedAmount]);

  const calculateTotalPrice = () => {
    const total = selectedTests.reduce((sum, item) => {
        return sum + (parseFloat(item.testPrice) || 0);
    }, 0);

    setTotalPrice(total);

    let discountAmount = 0;

    if (discountType === "percentage") {
        discountAmount = (total * discount) / 100;
    } else {
        discountAmount = parseFloat(discount) || 0;

        // Prevent discount greater than total
        if (discountAmount > total) {
            discountAmount = total;
        }
    }

    const finalGrandTotal = total - discountAmount;

    setDiscountAmmount(discountAmount);
    setGrandTotal(finalGrandTotal);
    SetDueAmount(finalGrandTotal - (parseFloat(ReceivedAmount) || 0));
};
  const handleChangedDiscount = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setDiscount(value);
  };

  // CRITICAL FIX: Safe state updates back to parent layout wrapped in useEffect
  useEffect(() => {
    const formattedTests = selectedTests.map((testItem) => ({
      TestID: testItem.testID,
      LaboratoryID: sessionStorage.getItem('LabID'),
      Created_at: new Date(),
      CreatedBy: sessionStorage.getItem('UserID'),
      UpdatedBy: sessionStorage.getItem('UserID'),
      TotalBill: totalprice,
      Discount: DiscountAmmount,
      GrandTotal: grandTotal,
      ReceivedAmount: ReceivedAmount,
      DueAmount: DueAmount,
    }));

    if (onSubmit) {
      onSubmit(formattedTests);
    }
  }, [selectedTests, totalprice, DiscountAmmount, grandTotal, ReceivedAmount, DueAmount, onSubmit]);

  const DiscountOptions = [
    { value: 0, label: '0%' }, { value: 5, label: '5%' }, { value: 10, label: '10%' },
    { value: 15, label: '15%' }, { value: 20, label: '20%' }, { value: 25, label: '25%' },
    { value: 30, label: '30%' }, { value: 35, label: '35%' }, { value: 40, label: '45%' },
    { value: 50, label: '50%' }, { value: 55, label: '55%' }, { value: 60, label: '60%' },
    { value: 65, label: '65%' }, { value: 70, label: '70%' }, { value: 75, label: '75%' },
    { value: 80, label: '80%' }, { value: 85, label: '85%' }, { value: 90, label: '90%' },
    { value: 95, label: '95%' }, { value: 100, label: '100%' }
  ];

  // Server side search function
  const [searchTerm, setSearchTerm] = useState("");
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeSubCategory, setActiveSubCategory] = useState(null);

  const OnSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Favorite category / sub-category / test quick filters, marked in Test Settings
  const [favoriteCategories, setFavoriteCategories] = useState([]);
  const [favoriteSubCategories, setFavoriteSubCategories] = useState([]);

  const loadFavoriteTags = async () => {
    try {
      const [categoryList, subCategoryList] = await Promise.all([
        Get_Categorry(Params.LabID),
        Get_SubCategory(Params.LabID),
      ]);
      setFavoriteCategories((categoryList || []).filter((c) => c.isFavorite));
      setFavoriteSubCategories((subCategoryList || []).filter((s) => s.isFavorite));
    } catch (error) {
      console.error('Error fetching favorite tags', error);
    }
  };

  useEffect(() => {
    loadFavoriteTags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const categoryGroups = useMemo(() => {
    return favoriteCategories
      .map((c) => ({
        value: c.categorY_VALUE,
        count: searchData.filter((t) => t.categorY_VALUE === c.categorY_VALUE).length,
      }))
      .filter((g) => g.count > 0);
  }, [favoriteCategories, searchData]);

  // Independent of Category selection - a Sub Category chip is shown as long as
  // it has matching tests, scoped to the active Category only when one is picked.
  const subCategoryGroups = useMemo(() => {
    return favoriteSubCategories
      .map((s) => {
        const items = activeCategory
          ? searchData.filter((t) => t.categorY_VALUE === activeCategory && t.suB_CATEGORY_VALUE === s.suB_CATEGORY_VALUE)
          : searchData.filter((t) => t.suB_CATEGORY_VALUE === s.suB_CATEGORY_VALUE);
        return { value: s.suB_CATEGORY_VALUE, count: items.length };
      })
      .filter((g) => g.count > 0);
  }, [favoriteSubCategories, searchData, activeCategory]);

  // Individually favorited tests, shown as one-click "add to order" chips
  const favoriteTestChips = useMemo(() => searchData.filter((t) => t.isFavorite), [searchData]);

  const selectCategory = (value) => {
    const turningOn = activeCategory !== value;
    setActiveCategory((prev) => (prev === value ? null : value));
    setActiveSubCategory(null);
    if (turningOn) {
      addAllMatchingTests(searchData.filter((t) => t.categorY_VALUE === value));
    }
  };

  const selectSubCategory = (value) => {
    const turningOn = activeSubCategory !== value;
    setActiveSubCategory((prev) => (prev === value ? null : value));
    if (turningOn) {
      const items = activeCategory
        ? searchData.filter((t) => t.categorY_VALUE === activeCategory && t.suB_CATEGORY_VALUE === value)
        : searchData.filter((t) => t.suB_CATEGORY_VALUE === value);
      addAllMatchingTests(items);
    }
  };

  const hasActiveFilter = !!(activeCategory || activeSubCategory || searchTerm.trim());

  const finaldataset = useMemo(() => {
    if (!hasActiveFilter) return [];

    let list = searchData;
    if (activeCategory) list = list.filter((t) => t.categorY_VALUE === activeCategory);
    if (activeSubCategory) list = list.filter((t) => t.suB_CATEGORY_VALUE === activeSubCategory);

    const cleanVal = searchTerm.trim().toLowerCase();
    if (cleanVal) {
      const query = ABBREVIATION_MAP[cleanVal] || cleanVal;
      list = list.filter((testItem) => {
        const testName = testItem.testName?.toLowerCase() || '';
        const category = testItem.categorY_VALUE?.toLowerCase() || '';
        const subCategory = testItem.suB_CATEGORY_VALUE?.toLowerCase() || '';
        return (
          testName.includes(query) ||
          category.includes(query) ||
          subCategory.includes(query)
        );
      });
    }
    return list;
  }, [searchData, activeCategory, activeSubCategory, searchTerm, hasActiveFilter]);

  // Receipt line items: when every test belonging to a category/sub-category
  // profile (e.g. all 8 CBC tests) is selected, collapse them into a single
  // "profile" line instead of listing each test - otherwise list tests as-is.
  const receiptLineItems = useMemo(() => {
    const groups = {};
    selectedTests.forEach((testItem) => {
      const key = `${testItem.categorY_VALUE || ''}|${testItem.suB_CATEGORY_VALUE || ''}`;
      if (!groups[key]) groups[key] = [];
      groups[key].push(testItem);
    });

    const items = [];
    Object.entries(groups).forEach(([key, testsInGroup]) => {
      const [category, subCategory] = key.split('|');
      const profileSize = searchData.filter(
        (t) => (t.categorY_VALUE || '') === category && (t.suB_CATEGORY_VALUE || '') === subCategory
      ).length;

      const isFullProfile = profileSize > 1 && testsInGroup.length === profileSize;

      if (isFullProfile) {
        const amount = testsInGroup.reduce((sum, t) => sum + (parseFloat(t.testPrice) || 0), 0);
        items.push({
          key,
          name: (subCategory || category || 'PROFILE').toUpperCase(),
          rate: amount,
          qty: 1,
          amount,
        });
      } else {
        testsInGroup.forEach((testItem) => {
          const priceVal = parseFloat(testItem.testPrice) || 0;
          items.push({
            key: testItem.testID,
            name: (testItem.testName || 'TEST').toUpperCase(),
            rate: priceVal,
            qty: 1,
            amount: priceVal,
          });
        });
      }
    });
    return items;
  }, [selectedTests, searchData]);

  const GetAgeGroup = async () => {
    try {
      const response = await Get_AgeGroup(sessionStorage.getItem('LabID'));
      SetAgegroupData(response);
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  useEffect(() => {
    GetAgeGroup();
  }, []);

  // Select All test from search list
  const SelectAllTest = (e) => {
    e.preventDefault();
    if (finaldataset.length > 0) {
      const updatedSelectedTests = [...selectedTests];
      finaldataset.forEach(testItem => {
        const alreadyExists = updatedSelectedTests.some(t => t.testID === testItem.testID);
        if (!alreadyExists) {
          updatedSelectedTests.push({ ...testItem, quantity: 1 });
        }
      });
      setSelectedTests(updatedSelectedTests);
      toast.info('All tests have been added to the selected list');
    } else {
      toast.error('No tests available to select');
    }
  };

  // Received and Due amount
  const onReceivedAmount = (e) => {
    const value = parseFloat(e.target.value) || 0;
    SetReceivedAmount(value);
    SetDueAmount(grandTotal - value);
  };

  const handleDirectPrint = () => {
  // 1. Grab only the inner HTML structure of the receipt layout
  const receiptHTML = document.querySelector('.popup-receipt-content').innerHTML;

  // 2. Open an isolated, blank browser window target
  const printWindow = window.open('', '_blank', 'width=600,height=600');

  // 3. Write standard document structures + your exact styling into the isolated target
  printWindow.document.write(`
    <html>
      <head>
        <title>Receipt Print</title>
        <style>
          body {
            margin: 0;
            padding: 2mm;
            width: 58mm;
            font-family: 'Courier New', Courier, monospace;
            font-size: 11px;
            color: #000;
            line-height: 1.4;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 11px;
          }
          /* Re-apply any explicit visual utilities used inside your popup component */
          div { word-break: break-word; }
        </style>
      </head>
      <body>
        ${receiptHTML}
      </body>
    </html>
  `);

  // 4. Close the document string execution loop, focus, and prompt the system printer immediately
  printWindow.document.close();
  printWindow.focus();

  // A small delay ensures the content is fully loaded into the new window before execution
  setTimeout(() => {
    printWindow.print();
    printWindow.close(); // Automatically dismisses the blank window element when finished/canceled
  }, 250);
};
  return (
    <>


      {isLoading && <SpinnerModal isLoading={true} />}
      <div className="container-fluid">
        <form className='child-container' onSubmit={(e) => e.preventDefault()}>
          <div className="row g-3">
            <div className="col-12 col-lg-6 search-Test-dev">
              <div className='common-FontFamily common-FontSize-small '>
                <div className='Parent-search-div'>
                  <div className='search-div'>
                    <input
                      name='SearchParam'
                      placeholder='Search Test'
                      className='search-input common-Input'
                      onChange={OnSearchChange}
                      value={searchTerm}
                    />
                    <button type='button' className='clear-button' onClick={ResetSearchList}>
                      <CancelIcon className='clear-cross' />
                    </button>
                  </div>
                </div>

                {(favoriteTestChips.length > 0 || categoryGroups.length > 0 || subCategoryGroups.length > 0) && (
                  <div className='category-chip-row'>
                    {favoriteTestChips.map((testItem) => (
                      <Chip
                        key={`test-${testItem.testID}`}
                        icon={<StarRoundedIcon style={{ color: '#f5b301' }} />}
                        label={testItem.testName}
                        size='small'
                        clickable
                        variant='outlined'
                        onClick={() => addToSelectedTests(testItem)}
                        className='common-FontFamily category-chip'
                      />
                    ))}
                    {categoryGroups.map((group) => (
                      <Chip
                        key={`category-${group.value}`}
                        icon={<StarRoundedIcon style={{ color: '#f5b301' }} />}
                        label={`${group.value} (${group.count})`}
                        size='small'
                        clickable
                        color={activeCategory === group.value ? 'primary' : 'default'}
                        variant={activeCategory === group.value ? 'filled' : 'outlined'}
                        onClick={() => selectCategory(group.value)}
                        className='common-FontFamily category-chip'
                      />
                    ))}
                    {subCategoryGroups.map((group) => (
                      <Chip
                        key={`subcategory-${group.value}`}
                        icon={<StarRoundedIcon style={{ color: '#f5b301' }} />}
                        label={`${group.value} (${group.count})`}
                        size='small'
                        clickable
                        color={activeSubCategory === group.value ? 'primary' : 'default'}
                        variant={activeSubCategory === group.value ? 'filled' : 'outlined'}
                        onClick={() => selectSubCategory(group.value)}
                        className='common-FontFamily category-chip'
                      />
                    ))}
                  </div>
                )}

                <ul className="search_List common-FontSize-small common-FontFamily common-FontWeight">
                  <li>
                    <button type="button" onClick={SelectAllTest} className='select-All-search-list common-FontSize-small common-FontFamily common-FontWeight'>Select All</button>
                  </li>
                  {finaldataset && finaldataset.length > 0 ? finaldataset.map((testItem) => (
                    <li key={testItem.testID} onClick={() => addToSelectedTests(testItem)}>
                      <span style={{ display: 'inline-block', minWidth: '50%' }}> {testItem.testName}</span> <span>{testItem.categorY_VALUE}</span>
                    </li>
                  )) : (
                    <p style={{ color: hasActiveFilter ? 'red' : 'gray', textAlign: 'center' }} className='common-FontFamily common-FontSize-small'>
                      {hasActiveFilter ? 'No Record Found' : 'Search a test or pick a category above'}
                    </p>
                  )}
                </ul>
              </div>
            </div>

            <div className="col-12 col-lg-6 TestList-dev common-FontSize-small common-FontFamily common-FontWeight">
              <div className="table-responsive">
                <table className="w-100">
                  <thead>
                    <tr>
                      <th className='Table-Th common-text-start common-FontSize-small common-FontFamily common-FontWeight'>Test</th>
                      <th className='Table-Th common-text-start common-FontSize-small common-FontFamily common-FontWeight'>Price</th>
                      <th className='Table-Th common-text-start common-FontSize-small common-FontFamily common-FontWeight'>Category</th>
                      <th className='Table-Th common-text-start common-FontSize-small common-FontFamily common-FontWeight'>Remove</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedTests.map((testItem) => (
                      <tr className='striped-row' key={testItem.testID}>
                        <td className='table-td'>{testItem.testName}</td>
                        <td className='table-td'>{testItem.testPrice}</td>
                        <td className='table-td'>{testItem.categorY_VALUE}</td>
                        <td className='table-td'>
                          <CloseRoundedIcon className="Cross" onClick={() => removeTest(testItem.testID)} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

          </div>

          <div className="row g-3 mt-1">
            <div className="col-12 common-FontSize-small common-FontFamily common-FontWeight Financial-dev">
              <div className='finance-section-heading'>
                <span>Discount and Total</span>
              </div>
              <div className='d-flex flex-wrap align-items-end gap-4 p-2'>
                <div className='d-flex flex-column'>
                  <label className='finance-item'>Total Price:</label>
                  <span className='finance-item f-item-border' style={{ background: 'lightgray' }}>
                    {totalprice}
                  </span>
                </div>

                <div className='d-flex flex-column'>
                  <label className='finance-item'>Discount:</label>
                  <div className="d-flex gap-2">
                    <select
                        value={discountType}
                        onChange={(e) => {
                            setDiscountType(e.target.value);
                            setDiscount(0);
                        }}
                    >
                        <option value="percentage">%</option>
                        <option value="amount">Rs</option>
                    </select>

                    {
                        discountType === "percentage" ? (
                            <span className='finance-item f-item-border'>
                                                    <select className='DiscountDropdown common-FontSize-small common-FontFamily common-FontWeight' name='Discount' onChange={handleChangedDiscount} value={discount}>
                                                      {DiscountOptions.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                          {option.label}
                                                        </option>
                                                      ))}
                                                    </select>
                                                  </span>
                        ) : (
                          <span className='finance-item f-item-border'>
                            <input
                                type="number"
                                placeholder="Discount Amount"
                                value={discount}
                                className='ReceivedAmmount common-FontSize-small common-FontFamily common-FontWeight'
                                onChange={(e) => setDiscount(parseFloat(e.target.value) || 0)}
                            />
                        </span>
                        )
                    }
                  </div>
                </div>

                <div className='d-flex flex-column'>
                  <label className='finance-item'>Grand Total:</label>
                  <span className='finance-item f-item-border' style={{ background: 'lightgray' }}>
                    {grandTotal}
                  </span>
                </div>

                <div className='d-flex flex-column'>
                  <label className='finance-item'>Paid:</label>
                  <span className='finance-item f-item-border'>
                    <input type="number" className='ReceivedAmmount common-FontSize-small common-FontFamily common-FontWeight' onChange={onReceivedAmount} value={ReceivedAmount} />
                  </span>
                </div>

                <div className='d-flex flex-column'>
                  <label className='finance-item'>Due Amount:</label>
                  <span className='finance-item f-item-border' style={{ background: 'lightgray' }}>
                    {DueAmount}
                  </span>
                </div>

                <div className='ms-lg-auto'>
                  <Button
                    onClick={() => setShowPrintModal(true)}
                    type='button'
                    variant="contained"
                    className="common-button">
                    View Receipt
                 </Button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      {/* POPUP PREVIEW OVERLAY */}
      {showPrintModal && (
        <div className="custom-print-overlay">
          <div className="custom-print-popup">

            {/* Scrollable Receipt Component wrapped in 58mm dimension styling */}
            <div className="popup-receipt-content">
              <div style={{ borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '6px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>LAB Name:</span>
                  <span>{sessionStorage.getItem('FirstName') || 'N/A'}{sessionStorage.getItem('LastName') || 'N/A'}</span>
                </div>
                {/* ADDED: Patient Name Field */}
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>PATIENT:</span>
                  <span style={{ fontWeight: 'bold' }}>{(patientName || 'N/A').toUpperCase()}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>DATE:</span>
                  <span>{new Date().toLocaleDateString()}</span>
                </div>
              </div>

              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
                <thead>
                  <tr style={{ borderBottom: '1.5px solid #000', textAlign: 'left' }}>
                    <th style={{ width: '55%' }}>Services</th>
                    <th style={{ textAlign: 'right', width: '20%' }}>Rate</th>
                    <th style={{ textAlign: 'center', width: '10%' }}>Qty</th>
                    <th style={{ textAlign: 'right', width: '15%' }}>AMT</th>
                  </tr>
                </thead>
                <tbody>
                  {receiptLineItems.map((item) => (
                    <tr key={item.key} style={{ verticalAlign: 'top' }}>
                      <td style={{ padding: '4px 0', wordBreak: 'break-word' }}>{item.name}</td>
                      <td style={{ padding: '4px 0', textAlign: 'right' }}>{item.rate}</td>
                      <td style={{ padding: '4px 0', textAlign: 'center' }}>{item.qty}</td>
                      <td style={{ padding: '4px 0', textAlign: 'right' }}>{item.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div style={{ marginTop: '4px', borderTop: '1px solid #000', paddingTop: '4px' }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', fontWeight: 'bold' }}>
                  <span style={{ width: '40%', textAlign: 'left' }}>Total</span>
                  <span style={{ width: '30%', textAlign: 'right' }}>{totalprice}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <span style={{ width: '40%', textAlign: 'left' }}>Paid</span>
                  <span style={{ width: '30%', textAlign: 'right' }}>{ReceivedAmount || 0}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px dashed #000', marginTop: '2px', paddingTop: '2px' }}>
                  <span style={{ width: '40%', textAlign: 'left' }}>Balance</span>
                  <span style={{ width: '30%', textAlign: 'right' }}>{DueAmount}</span>
                </div>
              </div>

              <div style={{ marginTop: '15px', fontSize: '9px', textAlign: 'left', borderTop: '1px solid #000', paddingTop: '5px' }}>
                <div>* This is a computer generated receipt.</div>
                <div>* Please bring this receipt for collection of reports.</div>
              </div>
            </div>

            {/* Popup Interaction Toolbar */}
            <div className="popup-action-row">
             <button
              type="button"
              className="btn btn-success w-50 common-FontFamily common-FontSize-small"
              onClick={handleDirectPrint}
            >
              Print
            </button>
              <button
                type="button"
                className="btn btn-danger w-50 common-FontFamily common-FontSize-small"
                onClick={() => setShowPrintModal(false)}
              >
                Close
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
});

export default LabOrder;
